import { Col as FlexCol, Container as FlexGrid, Row as FlexRow } from 'react-grid-system';
import styled from 'styled-components';

import { Breakpoint, Spacing } from '~/src/atomic/obj.constants';

export const APPLE_BUTTON_MAX_WIDTH_PX = 375;
export const MARGINS_WIDTH_PX = 16 * 2;

// Setting max-width to 407px because Apple Social Login button has a max width of 375px:
// https://developer.apple.com/documentation/sign_in_with_apple/displaying_sign_in_with_apple_buttons_on_the_web
// Adding Apple's button max width and our default margins sizes we get 375 + (16*2) = 407px.
const GridStyled = styled(FlexGrid)`
  max-width: ${APPLE_BUTTON_MAX_WIDTH_PX + MARGINS_WIDTH_PX}px;
`;

export interface RowProps {
  mb?: boolean;
  mt?: boolean;
  noGutter?: boolean;
}

const RowStyled = styled(FlexRow)<RowProps>`
  margin-bottom: ${(props) => (props.mb ? Spacing.Medium : '0px')};
  margin-top: ${(props) => (props.mt ? Spacing.Medium : '0px')};

  ${(props) =>
    props.noGutter &&
    `overflow: hidden;
      margin-left: -${rowMargin}rem;
      margin-right: -${rowMargin}rem;`}
`;

const ColStyled = styled(FlexCol)`
  max-width: 100%;
`;

export const Grid = GridStyled;
export const Col = ColStyled;
export const Row = RowStyled;

export const GridSettings = {
  gridSize: 12,
  // Defaults
  gutterWidth: 2, // rem
  outerMargin: 1, // rem
  breakpoints: [Breakpoint.xs, Breakpoint.sm, Breakpoint.md, Breakpoint.lg],
  container: {
    sm: 46, // rem
    md: 61, // rem
    lg: 76, // rem
  },
};

export const rowMargin = GridSettings.outerMargin + GridSettings.gutterWidth / 2;
